export interface ProfileSlice {
  unblock: boolean;
  setUnblock: (value: boolean) => void;
}

export const createProfileSlice = (set: any): ProfileSlice => ({
  unblock: false,
  setUnblock: (value) => set({ unblock: value }),
});
